import React, { useEffect } from "react";

import { selectUser } from "../src/features/userSlice";
import { useSelector } from "react-redux";

import PublicRoute from "./routes/PublicRoutes/index";
import { PrivateRoute } from "./routes/PrivateRoutes/index";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from 'sonner'


const queryClient = new QueryClient();

function App() {

  const user = useSelector(selectUser);
  useEffect(() => {}, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-center" richColor />
      <div>{user ? <PrivateRoute /> : <PublicRoute />}</div>
    </QueryClientProvider>
  );
}

export default App;
